// extracted by mini-css-extract-plugin
module.exports = {"description":"external-link-modal_description__cZa7y"};